import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDefectInzetbaarXs = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.81001 1.51L12.27 14H14.01C14.29 14 14.51 14.22 14.51 14.5C14.51 14.78 14.29 15 14.01 15H2.01001C1.73001 15 1.51001 14.78 1.51001 14.5C1.51001 14.22 1.73001 14 2.01001 14H3.74001L7.19001 1.51C7.26001 1.2 7.55001 1 7.86001 1H8.14001C8.45001 1 8.74001 1.2 8.81001 1.51ZM6.71001 7L5.60001 11H10.41L9.30001 7H6.71001ZM8.00501 2.33804L6.99001 6H9.02001L8.00501 2.33804ZM11.22 14L10.67 12H5.31001L4.76001 14H11.22Z'
    />
  </svg>
);
export default SvgDefectInzetbaarXs;
